import { createAction } from '@reduxjs/toolkit';
import { DriversSortBy } from '../../api/drivers/types';

export const setDriversKeyword = createAction<string>('SET_DRIVERS_KEYWORD');

export const setDriversSort = createAction<DriversSortBy | undefined>('SET_DRIVERS_SORT');

export const setAddDriverMode = createAction<boolean>('SET_ADD_DRIVER_MODE');
